'use strict';

var moment = require('moment-timezone');
var buildSimpleValidator = require('./helpers/build-simple-validator');

var allZoneNames = moment.tz.names();

module.exports = buildSimpleValidator(function (value) {
  return allZoneNames.includes(value);
}, 'Value must be a valid timezone string');